import React, {useEffect, useState, useRef} from 'react'
import {
  useGetCalculatedCumulativeDegreeDayQuery,
  useGetStationMaxMinDateQuery, 
  useGetPestThresholdQuery, 
  useGetNotificationSubcriptionStatusQuery,
  useCreatePestNotificationSubscriptionMutation,
  useDeletePestNotificationSubscriptionMutation, } from 'api/degreeDaysApi';
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { Grid } from "@mui/material";
import Loading from 'components/Loading';
import { Button, Modal, Card} from 'antd';
import { LeftCircleOutlined } from '@ant-design/icons';
import { DatePicker, Form } from 'antd';
const { RangePicker } = DatePicker;
import { Tabs, Table } from 'antd';
import SummaryCards from './SummaryCards';
import moment  from 'moment-timezone';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Spin } from 'antd';
import { mapThresholds } from 'utils/helper';

import { useDispatch } from "react-redux";

const { TabPane } = Tabs;

const getCurrentWeek = () => {
  const today = moment.tz('America/Halifax');
  const firstDayOfRange = today.clone().subtract(2, 'days');
  const lastDayOfRange = today.clone().add(14, 'days');
  return [firstDayOfRange, lastDayOfRange];
};


const DegreeDaysChart = () => {
    const { pestId, pestName, cropId,cropName, stationId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentYear = new Date().getFullYear();
    const chartRef = useRef(null);
    const [dateRange, setDateRange] = useState(getCurrentWeek());
    const { isOpen, componentData } = useSelector(
      (state) => state.pestThresholdModal
    );
    const minMaxDateQuery = useGetStationMaxMinDateQuery({
      pestId: pestId,
      stationId: stationId
    });
    const [stationName, setStationName] = useState();
    const [minMaxDate, setMinMaxDate] = useState({});
    const startDate = dateRange[0]?.toISOString();
    const endDate = dateRange[1]?.toISOString();
    const [chartSeries, setChartSeries] = useState([]);
    const [isChartSeriesLoading, setChartSeriesLoading] = useState(true);
    const [fetchTriggered, setFetchTriggered] = useState(false);
    const [IsDataRangeChange, setIsDateRangeChange] = useState(false);
    const [todayCDD, setTodayCDD] = useState();
    const [todayDegreeDay, setTodayDegreeDay] = useState();
    const {
      data: degreeDayQueryData,
      status: degreeDayQueryStatus,
      isError: degreeDayQueryIsError,
      isSuccess: degreeDayQueryIsSuccess,
      isLoading: degreeDayQueryIsLoading,
      error: degreeDayQueryError
    } = useGetCalculatedCumulativeDegreeDayQuery({
        pestId: pestId,
        stationId: stationId,
        startDate: startDate,
        endDate: endDate,
       
      });
    const [pestThresholdValue, setPestThresholdValue] = useState({
      stageThresholds : [],
      percentageThresholds : [],
      generationThresholds :[]
    })

    const [degreeDays, setDegreeDays] = useState([]);
    const today = moment.tz('America/Halifax').startOf('day').valueOf(); 
 
  const [pestThreshold, setPestThreshold] = useState({});
  const pestThresholdQuery = useGetPestThresholdQuery({pestId: pestId});
  const [tableDataValue, setTableDataValue] = useState();
  const [currentDegreeDateRange, setCurrentDegreeDateRange]  = useState({
    startDate:  startDate,
    endDate: endDate
  });

dayjs.extend(customParseFormat);
  const dateFormat = 'YYYY/MM/DD';

  
  
    const [options,setOptions] = useState({
      chart: {
        type: 'area',
        height: 400,
        toolbar:{
          tools: {
            download:  `
         <div style="display: inline-block; font-size: 10px; font-family: Arial, sans-serif; color: #333; margin-right: 20px; background-color: #b6f6e0; padding: 1px 3px; border: 1px solid #91e8d1; border-radius: 4px; cursor: pointer; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); text-align: center; transition: all 0.3s ease;">
  Download
</div>

          `,
          }
        
        },
        zoom: {
          enabled: false
        }
      },
      
      xaxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        },
      },
      yaxis: {
        title: {
          text: "Degree Days"
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      annotations: {
        xaxis: [
          {
            x: today,
            borderColor: '#00E396',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396'
              },
              text: 'Today'
            }
          }
        ],
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: 0,
                to: 100,
                color: '#008FFB' 
              },
              {
                from: 100,
                to: Infinity,
                color: '#FF4560'
              }
            ]
          }
        }
      },
   
    },
    
);

const customStyles = `
  .custom-download {
    margin-right: 10px;
    display: inline-block;
  }
`;

useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = customStyles;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);

const columns = [
  {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => <span>{moment(text).format('YYYY-MM-DD')}</span>,
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      defaultSortOrder: 'ascend'
  },
  {
    title: 'Degree Days',
    dataIndex: 'dailyDegreeDays',
    key: 'dailyDegreeDays',
    sorter: true,
},
  {
      title: 'Cumulative Degree Days',
      dataIndex: 'cumulativeDegreeDays',
      key: 'cumulativeDegreeDays',
      sorter: true, 
  },

  { title: "Crossed Thresholds", dataIndex: "crossedThresholds", key: "crossedThresholds" },
];


const handleDateChange = (dates) => {
  if (dates) {
    const [start, end] = dates;
  
    setDateRange([start.toDate(), end.toDate()]);
  } else {
    setDateRange(getCurrentWeek());
  }
};

const handleFetchData = () => {
  setFetchTriggered(true);
  setChartSeriesLoading(true);

  if (chartRef.current) {
    chartRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

useEffect(() => {
  if (!degreeDayQueryData || !degreeDayQueryData.dailyCumulativeDegreeDays) {
    console.warn("No degree day data available.");
    return;
  }

  const cumulativeDegreeDay = degreeDayQueryData.dailyCumulativeDegreeDays || [];
  const stationName = degreeDayQueryData.stationName || "Unknown Station";

  const degreeDayData = cumulativeDegreeDay.map((item) => ({
    x: new Date(item.date).getTime(),
    y: item.dailyDegreeDay,
  }));

  const cumulativeData = cumulativeDegreeDay.map((item) => ({
    x: new Date(item.date).getTime(),
    y: item.cumulativeDegreeDay,
  }));

  const xThresholdLines = [];
  const yThresholdLines = [];
  let minY = Infinity;
  let maxY = -Infinity;

  const handledXThresholds = new Set();
  const handledYThresholds = new Set();

  cumulativeDegreeDay.forEach((record) => {
    const { indicatorMessage, value } = mapThresholds(
      degreeDayQueryData.thresholdType,
      record.cumulativeDegreeDay,
      degreeDayQueryData.generationThresholds || [],
      degreeDayQueryData.percentageThresholds || [],
      degreeDayQueryData.stageThresholds || []
    );

    if (value) {
      const uniqueXKey = `${record.date}-${indicatorMessage}`;

      if (!handledXThresholds.has(value)) {
        xThresholdLines.push({
          x: new Date(record.date).getTime(),
          borderColor: "#FF4560",
          strokeDashArray: 4,
          label: {
            text: indicatorMessage || `Threshold (${value})`,
            style: {
              color: "#fff",
              background: "#FF4560",
            },
          },
        });

        handledXThresholds.add(value);
      }
    }
  });

  [
    ...(degreeDayQueryData.generationThresholds || []),
    ...(degreeDayQueryData.percentageThresholds || []),
    ...(degreeDayQueryData.stageThresholds || []),
  ].forEach((threshold) => {
    if (threshold.cddThreshold) {
      const { indicatorMessage, value } = mapHorizontalThresholds(
        degreeDayQueryData.thresholdType,
        threshold.cddThreshold,
        degreeDayQueryData.generationThresholds || [],
        degreeDayQueryData.percentageThresholds || [],
        degreeDayQueryData.stageThresholds || []
      );

      if (!handledYThresholds.has(value)) {
        yThresholdLines.push({
          y: value,
          borderColor: "#FF4560",
          strokeDashArray: 4,
          label: {
            text: indicatorMessage || `Threshold (${value})`,
            style: {
              color: "#fff",
              background: "#FF4560",
            },
          },
        });

        minY = Math.min(minY, value);
        maxY = Math.max(maxY, value);

        handledYThresholds.add(value);
      }
    }
  });

  setOptions((prevOptions) => ({
    ...prevOptions,
    annotations: {
      xaxis: [...xThresholdLines], 
      yaxis: [...yThresholdLines], 
    },
    yaxis: {
      min: minY, 
      max: maxY,
    },
    title: {
      text: `${stationName} Station`,
      align: "left",
    },
  }));

  setChartSeries([
    { name: "Degree Days", data: degreeDayData },
    { name: "Cumulative Degree Days", data: cumulativeData },
  ]);

}, [degreeDayQueryData, fetchTriggered]); 


    useEffect(() => {
      if (!degreeDayQueryData || !degreeDayQueryData.dailyCumulativeDegreeDays) {
        return;
      }
    
      const cumulativeDegreeDay = degreeDayQueryData.dailyCumulativeDegreeDays || [];
      const thresholdType = degreeDayQueryData.thresholdType || "";
      const generationThresholds = degreeDayQueryData.generationThresholds || [];
      const percentageThresholds = degreeDayQueryData.percentageThresholds || [];
      const stageThresholds = degreeDayQueryData.stageThresholds || [];
    
      const tableData = cumulativeDegreeDay.map((item, index) => {
        const { message: crossedThresholdMessage } = mapThresholds(
          thresholdType,
          item.cumulativeDegreeDay,
          generationThresholds,
          percentageThresholds,
          stageThresholds
        );
    
        return {
          key: index,
          date: item.date,
          dailyDegreeDays: item.dailyDegreeDay,
          cumulativeDegreeDays: item.cumulativeDegreeDay,
          crossedThresholds: crossedThresholdMessage,
        };
      });
    
      setTableDataValue(tableData);
    }, [degreeDayQueryData]); 
    

      const tableData = tableDataValue;

      const downloadChart = (type) => {
        const chart = window.ApexCharts.instances[0]; 
        if (chart) {
          chart.exportChart(type); 
        }
      };



  if(degreeDayQueryIsLoading ){
   return <Spin spinning={degreeDayQueryIsLoading } fullscreen />
  }

      
  return (
    <Grid container spacing= {2}>
         <Grid item xs={12} lg={12}>
          <Form.Item label="Need Historical DDs Data? Select Date Range">
        <RangePicker
        defaultValue={[dayjs(currentDegreeDateRange.startDate, dateFormat), dayjs(currentDegreeDateRange.endDate, dateFormat)]}
         style={{  borderWidth:2 ,borderStyle: "solid", borderColor: "#bae7ff",  borderRadius: "10px"  }} 
         size="large"
        onChange={handleDateChange}
        />
      </Form.Item>
      <Button type="primary" size="large"  onClick={handleFetchData}>
          Fetch Data
        </Button>
          {/* </Flex> */}
       
      </Grid>
      <Grid container item>
      {
  <SummaryCards />
  }
      </Grid>
      
 
      
    <Grid item xs={12} ref={chartRef}>
      <Card>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Chart" key="1">
          {/* Place your existing chart rendering logic here */}
          {chartSeries[0]?.data?.length === 0 && isChartSeriesLoading && degreeDayQueryIsSuccess ? (
            <Loading />
          ) : degreeDayQueryIsError ? (
            <Modal
              title="Data Unavailable"
              visible={true}
              footer={[
                <Button key="back" onClick={() => navigate(-1)} icon={<LeftCircleOutlined />}>
                  Go Back
                </Button>,
              ]}
              onCancel={() => navigate(-1)}
            >
             {degreeDayQueryError?.data}
            </Modal>
          ) : (
            <>
         
             <ReactApexChart options={options} series={chartSeries} type="area" height={500} />
             
            </>
           
          )}
        </TabPane>
        <TabPane tab="Table" key="2">
          {/* Render your table here */}
          <Table columns={columns} dataSource={tableData} pagination={false} />
        </TabPane>
      </Tabs>
    </Card>
    </Grid>
  
  </Grid>


   
  )
}

export default DegreeDaysChart




export const mapHorizontalThresholds = (
  thresholdType,
  thresholdValue,
  generationThresholds,
  percentageThresholds,
  stageThresholds
) => {
  let matchedThreshold = null;
  let indicatorMessage = "";

  switch (thresholdType) {
    case "GenerationDirect":
      for (let i = 0; i < generationThresholds.length; i++) {
        const currentThreshold = generationThresholds[i];

        if (thresholdValue === currentThreshold.cddThreshold) {
          matchedThreshold = currentThreshold.cddThreshold;
          indicatorMessage = `${getOrdinal(currentThreshold.generationName)} Generation`;
          break;
        }
      }
      break;

    case "GenerationPercentageDirect":
      for (let i = 0; i < generationThresholds.length; i++) {
        const generation = generationThresholds[i];
        generation.percentages.forEach((percentage) => {
          if (thresholdValue === percentage.cddThreshold) {
            matchedThreshold = percentage.cddThreshold;
            indicatorMessage = `${getOrdinal(generation.generationName)} Gen ${percentage.percentageValue}%`;
          }
        });
      }
      break;

    case "GenerationPercentageStage":
      for (let i = 0; i < generationThresholds.length; i++) {
        const generation = generationThresholds[i];
        generation.percentages.forEach((percentage) => {
          percentage.developmentStages.forEach((stage) => {
            if (thresholdValue === stage.cddThreshold) {
              matchedThreshold = stage.cddThreshold;
              indicatorMessage = `${getOrdinal(generation.generationName)} Gen ${percentage.percentageValue}% - ${stage.stageName}`;
            }
          });
        });
      }
      break;

    case "PercentageDirect":
      percentageThresholds.forEach((percentage) => {
        if (thresholdValue === percentage.cddThreshold) {
          matchedThreshold = percentage.cddThreshold;
          indicatorMessage = `${percentage.percentageValue}%`;
        }
      });
      break;

    case "PercentageStage":
      percentageThresholds.forEach((percentage) => {
        percentage.developmentStages.forEach((stage) => {
          if (thresholdValue === stage.cddThreshold) {
            matchedThreshold = stage.cddThreshold;
            indicatorMessage = `${percentage.percentageValue}% - ${stage.stageName}`;
          }
        });
      });
      break;

    case "Stage":
      stageThresholds.forEach((stage) => {
        if (thresholdValue === stage.cddThreshold) {
          matchedThreshold = stage.cddThreshold;
          indicatorMessage = `${stage.stageName}`;
        }
      });
      break;

    default:
      break;
  }

  return { value: matchedThreshold, indicatorMessage };
};


const getOrdinal = (number) => {
  if (!number || isNaN(number)) return number;
  const suffixes = ["th", "st", "nd", "rd"];
  const v = number % 100;
  return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};
